import { buttons } from '../../themes/'
import { lightTheme } from '../../themes'
export default {
    container: {
        marginTop: '15px',
        marginBottom: '15px',
        paddingLeft: '15px',
        paddingRight: '15px'
    },
    button: {
      default: buttons.default,
      pink: {
        ...buttons.default,
        backgroundColor: lightTheme.palette.primary.main
      },
      gray: {
        ...buttons.default,
        backgroundColor: '#9da5b6'
      },
      circlePink: {
        ...buttons.default,
        backgroundColor: lightTheme.palette.primary.main,
        minWidth: '100%',
        borderRadius: '100%'
      },
      disabled: {
        ...buttons.default,
        backgroundColor: '#dddddd',
        minWidth: '100%',
        borderRadius: '100%'
      }
    }
}
